var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var DELETE_MESSAGING_ACCOUNT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation DeleteMessagingAccount($id: uuid!) {\n        delete_messaging_account(id: $id) {\n            id\n        }\n    }\n"], ["\n    mutation DeleteMessagingAccount($id: uuid!) {\n        delete_messaging_account(id: $id) {\n            id\n        }\n    }\n"])));
var templateObject_1;
